<template>
	<div class="zapier-props">
		<div class="api-panel brdr_content_wrpr">
			<h3 class="brdr_content_title df">API credentials</h3>

			<ul class="numbered-list">
				<li>
					<span class="desc">
						There is no need to create a product automation to use Zapier, only press the button below to create new Zaps.
		      </span>

					<div class="layout-row">
						<v-button target="_blank"
						          href="https://zapier.com/developer/public-invite/11655/289e6b41b5986c758db5f024e551411d/">
							Create a Zap
						</v-button>
					</div>
				</li>
				<li>
					<span class="desc">
						Copy the following <b>Private API Key</b> into your Zapier integration to connect it to Funnelish when requested.
		      </span>
					<div class="api-panel-inner">
						<input-field small is-copy select-all class="flex"
						             v-model="user.private_api_key"></input-field>
						<div style="width: 8px"></div>
						<v-button border class="reset-key-btn flex-none" label="Reset"
						          @click="resetApiKey" :loading="resettingApiKey"/>
					</div>
					<span class="note">
		        <b style="color: red">*</b> Keep this API Key safe and do not share it.
		      </span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import API from "@/api";
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";

export default {
	name: "zapier-props",
	components: {InputField, VButton},
	mixins: [API],
	props:[],
	data(){
		return {
			resettingApiKey: false,
		}
	},
	computed:{
		user() {
			return this.$store.state.userInfo;
		},
	},
	methods:{
		async resetApiKey() {
			try {
				if (!confirm("Are you sure you want to regenerate your Private API Key?")) return;

				this.resettingApiKey = true;

				let resp = await this.api.users.resetApiKey();
				if (resp.error || resp.status !== 'OK') throw resp
				this.$info(null, "Your Private API Key regenerated, make sure to update integrations using the old API Key.");
				window.location.reload();
			} catch (e) {
				this.$error(e);
			} finally {
				this.resettingApiKey = false;
			}
		},
	},
	created() {
		this.$emit('valid',false)
	}
}
</script>

<style lang="scss" scoped>
.zapier-props {
	.api-panel {
		.api-panel-inner {
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		.desc {
			margin: 25px 0 10px;
			display: block;
		}
		.note {
			margin: 5px;
			display: block;
		}
		.reset-key-btn {
			width: auto;
			white-space: nowrap;
			height: 30px;
			padding: 6px 20px;
			font-size: 12px;
		}
	}
}
</style>
